export const useXtractStorage = () => {

  const isStorageAvailable = (type) => {
    let storage;
    try {
      storage = window[type];
      const x = '__storage_test__';
      storage.setItem(x, x);
      const result = storage.getItem(x);
      storage.removeItem(x);
      return result == x;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      );
    }
  }

  // Store a reference to the original methods
  const originalSetItem = Storage.prototype.setItem
  const originalGetItem = Storage.prototype.getItem
  const originalRemoveItem = Storage.prototype.removeItem
  const originalClear = Storage.prototype.clear

  // can be set to true to add a bunch of extra logging when session/local storage is accessed
  const loggingEnabled = false
  // if you need to explicitly test with one or both types of storage disabled, temporarily
  // set the ...StorageAvailable var to false
  const localStorageAvailable = isStorageAvailable('localStorage')
  const sessionStorageAvailable = isStorageAvailable('sessionStorage')

  const logCall = (localStorage, methodName, key, value) => {
    const storageType = localStorage ? 'localStorage' : 'sessionStorage'
    if(loggingEnabled) {
        const formattedValue = value ? ` with value "${value}"` : ''
        const formattedKey = key ? ` for key "${key}"` : ''
        console.log(`[Storage Override] ${storageType} ${methodName} call${formattedKey}${formattedValue}.`)
    }
  }

  // Override setItem for both local and session storage
  Storage.prototype.setItem = function(key, value) {
    const storageAvailable = this === localStorage ? localStorageAvailable : sessionStorageAvailable
    logCall(this === localStorage, 'setItem', key, value)
    if(storageAvailable) {
        this === localStorage ? originalSetItem.call(this, key, value) : originalSetItem.call(this, key, value)
        return true
    }
    return false
  };

  // Override getItem for both local and session storage
  Storage.prototype.getItem = function(key) {
    const storageAvailable = this === localStorage ? localStorageAvailable : sessionStorageAvailable
    logCall(this === localStorage, 'getItem', key)
    if(storageAvailable) {
        return this === localStorage ?  originalGetItem.call(this, key) : originalGetItem.call(this, key)
    } else {
        return null
    }
  };

  // Override removeItem for both local and session storage
  Storage.prototype.removeItem = function(key) {
    const storageAvailable = this === localStorage ? localStorageAvailable : sessionStorageAvailable
    logCall(this === localStorage, 'removeItem', key)
    if(storageAvailable) {
        this === localStorage ? originalRemoveItem.call(this, key) : originalRemoveItem.call(this, key)
    }
  };

  // Override clear for both local and session storage
  Storage.prototype.clear = function() {
    const storageAvailable = this === localStorage ? localStorageAvailable : sessionStorageAvailable
    logCall(this === localStorage, 'clear')
    if(storageAvailable) {
        this === localStorage ? originalClear.call(this) : originalClear.call(this)
    }
  };

}